<!-- new-week-view.component.html -->
<div class="container-fluid">
	<!-- Page Header with Utility Buttons -->
	<div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
		<h1 class="page-header mb-2 mb-lg-0">Week View</h1>

		<!-- Utility Buttons -->
		<div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
			<!-- Summary Details (Hidden for now) -->
			<div class="mb-2 mb-md-0 me-md-3" *ngIf="false">
				<button type="button" class="btn btn-link p-0 text-decoration-none text-reset align-baseline"
					[matMenuTriggerFor]="summaryBreakdownMenu" title="Show per-instructor breakdown">
					<span>Overall Summary: </span>
					<span title="Booked Daily">{{ summaryCount.privateLessonDaily }}</span>
					<sup title="Taken Daily">{{ summaryCount.privateTakenLessonDaily }}</sup>
					<b> / </b>
					<span title="Booked Weekly">{{ summaryCount.privateLessonWeekly }}</span>
					<sup title="Taken Weekly">{{ summaryCount.privateTakenLessonWeekly }}</sup>
					<mat-icon class="menu-dropdown align-middle">arrow_drop_down</mat-icon>
				</button>
				<mat-menu #summaryBreakdownMenu="matMenu">
					<div class="px-3 py-1" style="min-width: 240px;" (click)="$event.stopPropagation()">
						<div class="d-flex justify-content-between fw-bold small border-bottom pb-1 mb-1">
							<span>Category</span>
							<span>Daily / Weekly</span>
						</div>
						<div *ngFor="let row of summaryBreakdown"
							class="d-flex justify-content-between small py-1">
							<span class="me-3 text-truncate" style="max-width: 160px;">{{ row.label }}</span>
							<span class="text-nowrap">
								<span title="Booked Daily">{{ row.bookedDaily }}</span><sup title="Taken Daily">{{ row.takenDaily }}</sup>
								<b> / </b>
								<span title="Booked Weekly">{{ row.bookedWeekly }}</span><sup title="Taken Weekly">{{ row.takenWeekly }}</sup>
							</span>
						</div>
						<div *ngIf="!summaryBreakdown?.length" class="small text-muted py-1">
							No lessons to summarize.
						</div>
					</div>
				</mat-menu>
			</div>

			<!-- Button Group -->
			<div class="d-flex flex-wrap gap-1">
				<button style="color:#000; background-color: #82CFFD !important; border-color: #82CFFD !important;" mat-flat-button class="btn-color-status-update me-1 mb-1" mat-button
					[matMenuTriggerFor]="updateStatusMenu">
					Status Update
					<mat-icon aria-hidden="false" aria-label="Menu dropdown"
						class="menu-dropdown">arrow_drop_down
					</mat-icon>
				</button>
				<mat-menu #updateStatusMenu="matMenu">
					<button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-menu-item (click)="openDialog(UpdateLessonComponent, 'statusFormWithData', {eventData: this.Events} )">Update Lesson</button>
					<button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-menu-item (click)="openDialog(UpdateGroupLessonComponent, 'statusFormWithData', {eventData: this.Events} )">Update Group Lesson</button>
					<button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-menu-item (click)="openDialog(UpdateServiceComponent, 'statusFormWithData', {eventData: this.Events} )">Update Services</button>
				</mat-menu>

				<button *ngIf="_permissionsService.canAccess('lessons_create')" style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;" mat-flat-button class="me-1 mb-1" mat-button
					[matMenuTriggerFor]="newEventMenu" (menuOpened)="loadCoachingPackages()">
					New Event
					<mat-icon aria-hidden="false" aria-label="Menu dropdown"
						class="menu-dropdown">arrow_drop_down
					</mat-icon>
				</button>
				<mat-menu #newEventMenu="matMenu">
					<button mat-menu-item
						(click)="openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create')">
						Add Lesson
					</button>
					<button mat-menu-item
						(click)="openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'create')">
						Add Group Lesson
					</button>
					<button mat-menu-item
						(click)="openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'create')">
						Add Service
					</button>
					<button mat-menu-item
						(click)="openEntityComponent(EventSchedulesEntityComponent, 'events', 'schedules', 'create')">
						Add Schedule
					</button>
					<button mat-menu-item [matMenuTriggerFor]="coachingMenu">
						Add Coaching
					</button>
					<button *ngIf="_permissionsService.canAccess('students_create')" mat-menu-item
						(click)="openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
							'dayview_field_date_and_time': this.calendarDateInquiry,
							'inquiry': true
						})">
						Add Inquiry
					</button>
				</mat-menu>
				<mat-menu #coachingMenu="matMenu">
					<button mat-menu-item disabled *ngIf="coachingPackagesLoading">Loading…</button>
					<button mat-menu-item disabled *ngIf="!coachingPackagesLoading && coachingPackages.length === 0">No coaching packages</button>
					<button mat-menu-item *ngFor="let coachingPackage of coachingPackages"
						(click)="openCoachingLesson(coachingPackage, false)">
						{{ coachingPackage.name }}
					</button>
				</mat-menu>

				<button *ngIf="_permissionsService.canAccess('students_create')" class="mb-1" style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;" (click)="openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
					'dayview_field_date_and_time': this.calendarDateInquiry,
					'inquiry': true
				})" type="button"
					mat-button>
					Add Inquiry
				</button>
			</div>
		</div>
	</div>

	<!-- Filter Form  -->
	<mat-expansion-panel [expanded]="true">
		<mat-expansion-panel-header>
			<mat-panel-title>
				Filter
			</mat-panel-title>
			<mat-panel-description>
				Showing only events&nbsp;
				<span *ngIf="this.f?.form?.get('filterInstructor')?.value"> for {{ this.getNameFromId(this.f.form.get('filterInstructor').value, (this._fieldsService?.instructorData() || []).concat(this._fieldsService?.systemUsers() || []), 'value') }} Instructors&nbsp;</span>
				<span *ngIf="filterStudent"> for {{ filterStudent }}&nbsp; </span>
				<span *ngIf="filterGroupLesson || filterLesson || filterServices">
					that are
					<span *ngIf="filterGroupLesson"> Group Lessons </span>
					<span *ngIf="filterLesson"> Personal Lessons </span>
					<span *ngIf="filterServices"> Services </span>
					&nbsp;
				</span>
				<span *ngIf="filterDate">on {{ filterDateDisplay }}</span>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<form (ngSubmit)="updateCalendarEvents(f)" #f=ngForm class="form">
			<div class="row">
				<div class="col-12 col-sm-6 col-lg">
					<mat-form-field class="full-width-field">
						<mat-label>Select Instructor</mat-label>
						<mat-select
							matInput
							[(ngModel)]="field_instructor"
							name="filterInstructor"
							(selectionChange)="updateCalendarEvents(f)">
							<mat-option>None</mat-option>
							<ng-container *ngFor="let element of this._fieldsService.instructorData()">
								<mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_instructor)"
											[value]="element.uid">
									{{ element.value }}
									<ng-container *ngIf="element.status === '0' && element.uid === field_instructor"></ng-container>
								</mat-option>
							</ng-container>
							<!-- Web bookings sit on the Website Booking service account until a teacher takes them. -->
							<mat-option *ngFor="let element of this._fieldsService.systemUsers()" [value]="element.uid">
								{{ element.value }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div class="col-12 col-sm-6 col-lg">
					<mat-form-field class="full-width-field">
						<mat-label>Choose Lesson Type...</mat-label>
						<mat-select
							name="filterLessonType"
							ngModel
							(selectionChange)="updateCalendarEvents(f)">
							<mat-option>None</mat-option>
							<mat-option *ngFor="let lesson of lessonTypeOptions" [value]="lesson.id">{{lesson.value}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div class="col-12 col-sm-6 col-lg">
					<mat-form-field class="full-width-field">
						<mat-label>Student</mat-label>
						<input
							name="filterStudent"
							(input)="onStudentInput($event)"
							matInput
							ngModel
							(blur)="updateCalendarEvents(f)"
							[matAutocomplete]="auto"
							>
							<button *ngIf="_permissionsService.canAccess('students_view')" type="button" matSuffix mat-icon-button aria-label="manage_accounts" (click)="openStudentDashboard($event)">
								<mat-icon>manage_accounts</mat-icon>
							</button>
					</mat-form-field>
					<mat-autocomplete #auto="matAutocomplete"
							(optionSelected)="updateCalendarEvents(f)">
						<mat-option *ngFor="let option of autoCompleteOptions"
							[value]="option.label + ' ' + '(' + option.value + ')'">
							{{option.label}} ({{option.value}})
						</mat-option>
					</mat-autocomplete>
				</div>

				<app-calendar-week-selector
					[initialDate]="filterDate"
					[label]="'Choose a date'"
					[colClass]="'col-3'"
					(selectionChange)="onCalendarWeekChange($event)">
				</app-calendar-week-selector>
			</div>

			<section class="section">
				<mat-checkbox
					name="filterGroupLesson"
					class="margin"
					[(ngModel)]="filterGroupLesson"
					(change)="updateCalendarEvents(f)">Group Lesson</mat-checkbox>
				<mat-checkbox
					name="filterLesson"
					class="margin"
					[(ngModel)]="filterLesson"
					(change)="updateCalendarEvents(f)">Lesson</mat-checkbox>

				<mat-checkbox
					name="filterServices"
					class="margin"
					[(ngModel)]="filterServices"
					(change)="updateCalendarEvents(f)">Services</mat-checkbox>

				<mat-checkbox
					name="filterHiddenEvents"
					class="margin"
					[(ngModel)]="filterHiddenEvents"
					(change)="updateCalendarEvents(f)">Show Hidden Events</mat-checkbox>
			</section>
		</form>
	</mat-expansion-panel>

	<!-- Loading indicator while waiting for studio timezone -->
	<div *ngIf="!studioTimezoneLoaded" class="text-center p-5">
		<mat-spinner diameter="40" class="mx-auto"></mat-spinner>
		<p class="mt-3">Loading calendar...</p>
	</div>

	<!-- Error message when timezone is not configured -->
	<div *ngIf="studioTimezoneLoaded && studioTimezoneMissing" class="alert alert-warning text-center mt-4" role="alert">
		<mat-icon class="align-middle me-2">warning</mat-icon>
		<strong>Studio Timezone Not Configured</strong>
		<p class="mt-2 mb-2">
			The calendar cannot display correctly without a configured timezone.
			Please set your studio's timezone in the configuration settings.
		</p>
		<a routerLink="/configuration/studio-information" class="btn btn-primary">
			<mat-icon class="align-middle me-1">settings</mat-icon>
			Go to Studio Configuration
		</a>
	</div>

	<!-- Calendar only renders after studio timezone is loaded and configured -->
	<full-calendar *ngIf="studioTimezoneLoaded && !studioTimezoneMissing" class="mt-4" #calendar [options]="calendarOptions"></full-calendar>

	<!-- TODO: make this a component -->
	<div #customPopover class="popover in bg-transparent border-0 shadow-none" role="tooltip" id="custom-popover" style="display: none;">
		<app-booking-menu
			[canBookLessons]="_permissionsService.canAccess('lessons_create')"
			[canAddInquiry]="_permissionsService.canAccess('students_create')"
			[coachingPackages]="coachingPackages"
			[coachingPackagesLoading]="coachingPackagesLoading"
			[openKey]="bookingMenuOpenKey"
			(choose)="onBookingMenuChoice($event)"
			(coachingChoose)="openCoachingLesson($event, true); hideCustomPopover();"
			(close)="hideCustomPopover()">
		</app-booking-menu>
	</div>

	<!-- TODO: make this a component -->
	<div class="popover bottom in" role="tooltip" id="custom-context-menu" style="display: none;">
			<div class="arrow" style="left: 50%;"></div>
			<div class="popover-content">
					<div style="display: grid;">

							<div class="context-menu-item">
									<mat-icon>content_copy</mat-icon>
									<div (click)="copyClick()" type="button"
											class="context-button" target_element="lesson"
											title="Copy">
											Copy
									</div>
							</div>

							<div *ngIf="!isEventHidden()" class="context-menu-item">
									<mat-icon>visibility_off</mat-icon>
									<div (click)="hideClick()" type="button"
											class="context-button" target_element="lesson"
											title="Hide">
											Hide
									</div>
							</div>

							<div *ngIf="isEventHidden()" class="context-menu-item">
									<mat-icon>visibility</mat-icon>
									<div (click)="unhideClick()" type="button"
											class="context-button" target_element="lesson"
											title="Unhide">
											Unhide
									</div>
							</div>

							<!-- <div class="context-menu-item">
									<mat-icon>content_paste_off</mat-icon>
									<div (click)="pasteClick()" type="button"
											class="context-button" target_element="service"
											title="Paste">
											Paste
									</div>
							</div> -->

							<hr />
							<div class="context-menu-item">
									<mat-icon>close</mat-icon>
									<div (click)="closeContextMenu()" type="button"
											class="context-button"
											title="Close">
											Close
									</div>
							</div>
					</div>
			</div>
	</div>

</div>
